module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-link-wrap verticalM"
  }, [_c('img', {
    staticClass: "verticalM-box",
    attrs: {
      "src": "/static/images/home_logo_top_3x.png"
    },
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "verticalM-box"
  }, [_vm._v("美心·美家·美生活")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "verticalM-box"
  }, [_c('a', {
    attrs: {
      "href": "tel:400-832-2777"
    }
  }, [_vm._v("400-832-2777")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd624ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topLink/topLink.vue
// module id = 381
// module chunks = 68